import styled from 'styled-components';

export const ListSubtitle = styled.h2.attrs({
    className: 'list-subtitle',
})``;
